export class NL_Subeler{
    ID:number;
    SubeAdi:string;
    SubeAdres:string;
    VarsayilanMi:number;

}


// WEBPACK FOOTER //
// ./src/models/NL_Subeler.ts